import { apiClient } from "./client";

const BASE_PATH = "/users";

export const addressService = {
  /** Adresses plateforme isDefault=true (checkout invité). */
  async getDefaultDeliveryAddresses() {
    const response = await apiClient.get(
      `${BASE_PATH}/delivery-addresses/defaults`
    );
    return response.data;
  },

  async getDeliveryAddresses(userId, params = {}) {
    const response = await apiClient.get(`${BASE_PATH}/${userId}/delivery-addresses`, {
      params,
    });
    return response.data;
  },

  async createDeliveryAddress(userId, payload) {
    const response = await apiClient.post(
      `${BASE_PATH}/${userId}/delivery-addresses`,
      payload
    );
    return response.data;
  },

  async updateDeliveryAddress(userId, addressId, payload) {
    const response = await apiClient.put(
      `${BASE_PATH}/${userId}/delivery-addresses/${addressId}`,
      payload
    );
    return response.data;
  },

  async deleteDeliveryAddress(userId, addressId) {
    await apiClient.delete(`${BASE_PATH}/${userId}/delivery-addresses/${addressId}`);
  },
};
